<template>
  <div class="report-component w-100 h-100">
    <div
      class="report-container d-flex flex-column align-items-center justify-content-start w-100 h-100"
    >
      <div
        class="report-toolbar d-flex flex-row align-items-end justify-content-end flex-wrap w-100"
      >
        <HMDatePicker
          v-model="parameters.date"
          v-if="report.has_date_range"
          @input="loadReport"
        />
        <HMSwitchTabs
          class="ml-2"
          :selected.sync="parameters.period"
          v-if="report.has_interval"
          @change="loadReport"
        >
          <HMSwitchTab name="year">
            <span>
              {{ $t('REPORTS.FILTERS.YEAR') }}
            </span>
          </HMSwitchTab>
          <HMSwitchTab name="month">
            <span>
              {{ $t('REPORTS.FILTERS.MONTH') }}
            </span>
          </HMSwitchTab>
          <HMSwitchTab name="week">
            <span>
              {{ $t('REPORTS.FILTERS.WEEK') }}
            </span>
          </HMSwitchTab>
          <HMSwitchTab name="day">
            <span>
              {{ $t('REPORTS.FILTERS.DAY') }}
            </span>
          </HMSwitchTab>
        </HMSwitchTabs>
      </div>
      <div
        class="report-content mt-2 d-flex flex-grow-1 w-100"
        v-if="renderedReport"
      >
        <iframe
          :src="renderedReport.iframe_url"
          :key="renderedReport.iframe_url"
          frameborder="0"
          width="100%"
          allowtransparency
          onload="iFrameResize"
          ref="reportIFrame"
        ></iframe>
      </div>
      <HMSpinner v-else />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import moment from 'moment';
import { errorToMessage } from '../../../core/utils/errors';
import HMSwitchTabs from '@/web/components/common/HMSwitchTabs';
import HMSwitchTab from '@/web/components/common/HMSwitchTab';
export default Vue.extend({
  name: 'ReportComponent',
  components: {
    HMSwitchTabs,
    HMSwitchTab,
  },
  props: {
    report: {
      type: Object,
    },
    productId: {
      type: Number,
      default: null,
    },
    studentId: {
      type: Number,
      default: null,
    },
  },
  computed: {},
  data() {
    return {
      renderedReport: null,
      parametersInitialized: false,
      parameters: {
        period: 'day',
      },
      selectedProductId: null,
      selectedStudentId: null,
    };
  },
  methods: {
    iFrameResize() {
      window.iFrameResize({}, this.$refs['reportIFrame']);
    },
    setInitialParameters() {
      this.parameters.period = this.report.default_interval;
      if (this.report.has_interval) {
        // set up some default dates, depending on the selected range
        if (this.report.has_date_range) {
          if (this.parameters.period === 'day') {
            this.parameters.date = {
              startDate: moment().subtract(1, 'months').toDate(),
              endDate: new Date(),
            };
          } else if (this.parameters.period === 'week') {
            this.parameters.date = {
              startDate: moment().subtract(3, 'months').toDate(),
              endDate: new Date(),
            };
          } else if (this.parameters.period === 'month') {
            this.parameters.date = {
              startDate: moment().subtract(12, 'months').toDate(),
              endDate: new Date(),
            };
          } else if (this.parameters.period === 'year') {
            this.parameters.date = {
              startDate: moment().subtract(3, 'years').toDate(),
              endDate: new Date(),
            };
          }
        }
      } else {
        if (this.report.has_date_range) {
          this.parameters.date = {
            startDate: moment().subtract(1, 'months').toDate(),
            endDate: new Date(),
          };
        }
      }
      if (this.report.has_product_id) {
        this.parameters.product_id = this.productId;
      }
      if (this.report.has_student_id) {
        this.parameters.student_id = this.studentId;
      }
    },
    mapParameters() {
      if (!this.report.has_date_range) return this.parameters;
      const paramsCopy = _.cloneDeep(this.parameters);
      delete paramsCopy.date;
      return {
        ...paramsCopy,
        start_datetime: moment(this.parameters.date.startDate)
          .startOf('day')
          .toDate(),
        end_datetime: moment(this.parameters.date.endDate)
          .endOf('day')
          .toDate(),
      };
    },
    async loadReport() {
      const parameters = this.mapParameters();
      try {
        this.renderedReport = await this.$store.dispatch(
          'report/getMetabaseReport',
          {
            reportId: this.report.id,
            params: parameters,
          }
        );
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: 'Failed to load the report',
          text: errorToMessage(error.response, `Request failed: ${error}`),
          duration: -1, // stay ON
        });
      }
    },
  },
  watch: {
    report: {
      async handler(report) {
        if (report) {
          if (!this.parametersInitialized) {
            this.setInitialParameters();
            this.parametersInitialized = true;
          }
          await this.loadReport();
        }
      },
      immediate: true,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.report-content {
  min-height: 100%;
  height: 50vh;
  iframe {
    border: 1px solid $medium-gray;
    border-radius: 6px;
    min-width: 100%;
    overflow: hidden;
  }
}
</style>
